module.exports = __webpack_public_path__ + "static/img/jiaobiao-jinxingzhong.0f39f5ee.png";